<header
  [class]="`application-header expand-${expandBreakpoint()}`"
  [class.show-navigation]="mobileNavigationExpanded()"
>
  @if (launchpad()) {
    <button
      type="button"
      aria-haspopup="dialog"
      [class]="`header-toggle focus-inside d-${expandBreakpoint()}-block`"
      [class.show]="launchpadOpen()"
      [class.d-none]="hasNavigation()"
      [attr.aria-expanded]="launchpadOpen()"
      [attr.aria-label]="launchpadLabel() | translate"
      [attr.aria-controls]="id + '-launchpad'"
      (click)="toggleLaunchpad()"
    >
      <si-icon class="icon-lg" [icon]="icons.elementThumbnails" />
    </button>
  }
  @if (hasNavigation()) {
    <button
      #navigationToggle
      type="button"
      class="header-toggle focus-inside"
      [class.show]="mobileNavigationExpanded()"
      [attr.aria-expanded]="mobileNavigationExpanded()"
      [attr.aria-label]="toggleNavigation | translate"
      [attr.aria-controls]="id + '-navigation-wrapper'"
      (click)="toggleMobileNavigationExpanded()"
    >
      <si-icon class="icon-lg" [icon]="icons.elementMenu" />
    </button>
  }
  <ng-content select="si-header-brand, element-header-brand">
    <div class="header-brand"></div>
  </ng-content>

  <div
    class="d-contents"
    [id]="id + '-navigation-wrapper'"
    [cdkTrapFocus]="mobileNavigationExpanded()"
    (keydown.escape)="navigationEscapePressed()"
  >
    <ng-content select="si-header-navigation, element-header-navigation">
      <div class="header-navigation"></div>
    </ng-content>
  </div>

  <ng-content select="si-header-actions, element-header-actions">
    <div class="header-actions"></div>
  </ng-content>
</header>

@if (launchpadOpen() && launchpad()) {
  <div
    role="dialog"
    aria-modal="true"
    [id]="id + '-launchpad'"
    [attr.aria-label]="launchpadLabel() | translate"
  >
    <ng-template [ngTemplateOutlet]="launchpad()!" [ngTemplateOutletInjector]="injector" />
  </div>
}

@if (openDropdownCount() || launchpadOpen()) {
  <div
    [class]="`modal-backdrop ${launchpadOpen() ? 'd-block' : `d-${expandBreakpoint()}-none`}`"
    (click)="backdropClicked()"
  ></div>
}
